import "./App.css";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import Room from "./pages/Room";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import home6 from "./assets/images/home6.jpg";
import { useState } from "react";
import ChatWindow from "./components/ChatWindow.jsx";

// ✅ ChatButton fuori da App()
function ChatButton() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {isOpen && <ChatWindow onClose={() => setIsOpen(false)} />}
     <button
  onClick={() => setIsOpen(true)}
  className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white rounded-full w-16 h-16 shadow-2xl z-50 flex items-center justify-center"
  title="Chatta con noi"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 32 32"
    fill="white"
  >
    <path d="M16 .396C7.16.396 0 7.556 0 16.396c0 2.885.752 5.649 2.17 8.102L.073 31.438l7.149-2.008a15.918 15.918 0 0 0 8.778 2.566h.001c8.84 0 16-7.161 16-16.001C32 7.556 24.84.396 16 .396zm8.437 23.079c-.348.975-2.028 1.801-2.821 1.921-.72.108-1.63.152-2.633-.162-.605-.191-1.38-.447-2.391-.873-4.203-1.813-6.937-5.968-7.143-6.25-.205-.282-1.707-2.271-1.707-4.333 0-2.062 1.051-3.076 1.425-3.5.37-.421.82-.526 1.094-.526.273 0 .547.004.786.014.251.012.59-.095.922.7.348.836 1.179 2.894 1.282 3.105.104.209.174.46.035.743-.139.282-.209.46-.418.706-.209.247-.439.552-.628.743-.209.209-.426.437-.183.858.243.421 1.08 1.782 2.317 2.884 1.595 1.418 2.939 1.854 3.36 2.064.421.209.662.182.905-.104.243-.282 1.043-1.218 1.323-1.635.278-.421.556-.348.937-.209.382.139 2.422 1.141 2.84 1.348.418.209.697.313.8.487.104.174.104 1.009-.243 1.984z"/>
  </svg>
</button>

    </>
  );
}

// ✅ App principale
function App() {
  return (
    <div
      style={{
        backgroundImage: `linear-gradient(rgba(255,255,255,0.3), rgba(255,255,255,0.1)), url(${home6})`,
        backgroundRepeat: "repeat",
        backgroundSize: "20%", // più piccola = più continuità
        backgroundPosition: "top left",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Blog" element={<Blog />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Room" element={<Room />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/Gallery" element={<Gallery />} />
      </Routes>

      <Footer />

      {/* ✅ Chat Button qui sotto */}
      <ChatButton />
    </div>
  );
}

export default App;
